import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CarrierImportVerificationToolComponent } from './verification-tool/carrier-import-verification-tool.component';
import { CARRIER_IMPORT_ROUTES } from './carrier-import.routes';
import { CarrierImportService } from './shared/carrier-import.service';


@NgModule({
  imports: [
    RouterModule.forChild(CARRIER_IMPORT_ROUTES),
    SharedModule
  ],
  declarations: [
    CarrierImportVerificationToolComponent
  ],
  providers: [
    CarrierImportService
  ]
})
export class CarrierImportModule {
}
